import { Hero } from "@/components/home/Hero";
import { Marquee } from "@/components/Marquee";
import { Positionnement } from "@/components/home/Positionnement";
import { Materiaux } from "@/components/home/Materiaux";
import { Methode } from "@/components/home/Methode";
import { Plaquette } from "@/components/home/Plaquette";
import { LeadForm } from "@/components/LeadForm";
import { RecrutementTeaser } from "@/components/home/RecrutementTeaser";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Positionnement />
      <Materiaux />
      <Methode />
      <Plaquette />
      <LeadForm />
      <RecrutementTeaser />
    </main>
  );
}
